import client from '@libs/HttpClient';
class AllActivitiesService {
  //My All Task Master
  static listTask(request) {
    const page_no = request.currentPage;
    const selectedProject = request.selectedProject;
    const selectedEmployee = request.selectedEmployee;
    const selectedSprint = request.selectedSprint;
    const selectedInactiveUser = request.selectedInactiveUser;
    return client.get(
      `/all-activities?page=${page_no}&selectedProject=${selectedProject}&selectedEmployee=${selectedEmployee}&selectedSprint=${selectedSprint}&selectedInactiveUser=${selectedInactiveUser}`,
      request
    );
  }
  static getEmployees(request) {
    const projectIds = request.projectIds;
    return client.get(`/all-activities/all-employees?project_ids=${projectIds}`);
  }
  static projectList(request) {
    return client.get(
      `/all-activities/all-projects`,
      request
    );
  }
  static sprintList(request) {
    return client.get(
      `/all-activities/all-sprints/${request.project_id}`,
      request
    );
  }
}
export { AllActivitiesService };
